module.exports = __webpack_public_path__ + "static/media/seminars-primary.c7878596.jpg";